import StackedBar from '../../components/charts/bar/stackedBar/StackedBar';
import PieChartSummary from '../../components/charts/pie/PieChartSummary';
import PieChartSpending from '../../components/charts/pie/PieChartSpending';
import USAHeatmap from '../../components/charts/geographical/UsaHeatmap';
import MultiHeaderTable from '../../components/tables/MultiHeaderTable';
import FileExplorer from '../../components/fileExplorer/FileExplorer';
import BarChart from '../../components/charts/bar/simpleBar/BarChart';
import HeatmapGrid from '../../components/charts/grid/HeatmapGrid';
import DoughnutChart from '../../components/charts/pie/Doughnut';
import UsaChart from '../../components/charts/geographical/Usa';
import LineChart from '../../components/charts/line/LineChart';
import SimpleTable from '../../components/tables/dynamicTable';
import PieChart from '../../components/charts/pie/piechart';
import Badges from '../../components/common/badges/Badges';
import { pivotHeatmap } from '../transformers/pivotGridHeatmap';
import MultiArea from '../../components/charts/area/MultiArea';

const getChart = async(chartData, setHeight) => {
    let chartComponent;
    
    if (chartData.chartInfo) {
      switch (chartData.chartInfo[0].TYPE) {
        case 'STACKEDBAR':
          chartComponent = <StackedBar chartData={chartData.data} />;
          break;
        case 'DOWNLOADTABLE':
          const fileObject = {
            fileData: { fileObject: chartData.data },
            fileExplorerAttribute :{
              fileHeaders: ['File Name', 'Date', 'Download'], fileButtons: ['Remit Download']
            }
          };
          chartComponent = <FileExplorer fileObject={fileObject} />;
          break;
        case 'PIE':
          chartComponent = <PieChart chartData={chartData.data}/>;
          break;
        case 'PIECHARTSPENDING':
          chartComponent = (
            <PieChartSpending
              chartData={chartData.data?.chart1 || chartData.data}
              totalSpend={chartData.data?.totalSpend}
            />
          );
          break;
        case 'PIECHARTSUMMARY':
          chartComponent = <PieChartSummary chartData={chartData.data.chart1} secondaryChart={chartData.data.chart2}/>
          break;
        case 'ONBOARDING':
          chartComponent = <p>Welcome to the Portal.<br/>
            Currently there is no component available.<br/>
            Please contact GTMS to specify what you want shown here.</p>;
          break;
        case 'MULTIHEADERTABLE':
          chartComponent = <MultiHeaderTable chartData={chartData.data} /> 
          break;
        case 'BADGES': 
          setHeight('auto');
          chartComponent = <Badges chartData={chartData.data} />
          break;
        case 'TABLE':
          chartComponent = <SimpleTable dataObject={chartData} />
          break;
        case 'TABLE-WRAPPED':
          chartComponent = <SimpleTable dataObject={chartData.data} defaultSize = 'small'  />
          break;
        case 'USACHART':
          chartComponent = <UsaChart chartData={chartData} />
          break;
        case 'USA_HEATMAP':
          chartComponent = <USAHeatmap chartObject={chartData}/>;
          break;
        case 'LINE':
          chartComponent = <LineChart chartData={chartData.data} xKey={chartData.xKey} yKey={chartData.yKey}/>
          break;
        case 'DOUGHNUT':
          chartComponent = <DoughnutChart chartData={chartData.data} centerValue={chartData.centerValue}/>
          break;
        case 'BAR':
          chartComponent = <BarChart chartData ={chartData.data} xKey={chartData.xKey} yKey={chartData.yKey}/>
          break;
        case 'HEAT-MAP-GRID':
          const transformed = pivotHeatmap(chartData.data, chartData);
          chartComponent = <HeatmapGrid {...transformed}/>
          break;
        case 'MULTI-AREA-CHART':
          chartComponent = <MultiArea chartData={chartData.data} />
          break;
        default:
          chartComponent = <p>Error fetching chart</p>;
      }
    } else {
      chartComponent = 'Error fetching chart data';
    }
    return chartComponent;
  }

export default getChart;
